import * as x from "react";
import * as nt from "react-dom";
import { p as f } from "./index-efd35e77.js";
import { l as rt, v as it } from "./index-64063129.js";
const p = {
  bottom: "bottom",
  center: "center",
  middle: "middle",
  left: "left",
  right: "right",
  top: "top"
};
var ot = function(t) {
  var e = t.anchorRect, r = t.anchorAlign, n = t.elementRect, i = t.elementAlign, o = t.margin;
  o === void 0 && (o = {});
  var a = r.horizontal, l = r.vertical, s = i.horizontal, c = i.vertical, u = o.horizontal || 0, h = o.vertical || 0, d = e.top, g = e.left;
  return l === p.bottom && (d += e.height), (l === p.center || l === p.middle) && (d += Math.round(e.height / 2)), c === p.bottom && (d -= n.height, h *= -1), (c === p.center || c === p.middle) && (d -= Math.round(n.height / 2), h *= -1), a === p.right && (g += e.width), (a === p.center || a === p.middle) && (g += Math.round(e.width / 2)), s === p.right && (g -= n.width, u *= -1), (s === p.center || s === p.middle) && (g -= Math.round(n.width / 2), u *= -1), {
    top: d + h,
    left: g + u
  };
};
function at(t, e) {
  return {
    top: t.top + e.y,
    left: t.left + e.x,
    height: t.height,
    width: t.width
  };
}
function X(t) {
  return t.ownerDocument || t.document || t;
}
var k = function(t) {
  return X(t).defaultView;
}, M = function(t) {
  return X(t).documentElement;
}, z = 0;
function lt() {
  if (!z && typeof document < "u") {
    var t = document.createElement("div");
    t.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block", t.innerHTML = "&nbsp;", document.body.appendChild(t), z = t.offsetWidth - t.scrollWidth, document.body.removeChild(t);
  }
  return z;
}
function Y(t) {
  var e = k(t), r = M(t), n = {
    height: e.innerHeight,
    width: e.innerWidth
  };
  return r.scrollHeight - r.clientHeight > 0 && (n.width -= lt()), n;
}
var st = function(t) {
  if (!t.getBoundingClientRect) {
    var e = Y(t);
    return {
      bottom: e.height,
      left: 0,
      right: e.width,
      top: 0
    };
  }
  var r = t.getBoundingClientRect(), n = r.bottom, i = r.left, o = r.right, a = r.top;
  return {
    bottom: n,
    left: i,
    right: o,
    top: a
  };
}, I = function(t) {
  for (var e = t.offsetParent; e && e.style.position === "static"; )
    e = e.offsetParent;
  return e || M(t);
}, ft = function(t) {
  var e = t.style, r = e.display, n = e.left, i = e.position;
  t.style.display = "", t.style.left = "-10000px", t.style.position = "absolute";
  var o = t.getBoundingClientRect();
  return t.style.display = r, t.style.left = n, t.style.position = i, o;
}, R = function(t) {
  var e = t.getBoundingClientRect(), r = e.left, n = e.top;
  return !e.height && !e.width && (e = ft(t)), {
    top: n,
    left: r,
    height: e.height,
    width: e.width
  };
};
function q(t, e) {
  for (var r = [], n = t.parentNode; n && (r.push(n), n !== e); )
    n = n.parentNode;
  return r;
}
function G(t) {
  var e = M(t), r = k(t);
  return {
    x: r.pageXOffset || e.scrollLeft || 0,
    y: r.pageYOffset || e.scrollTop || 0
  };
}
function J(t) {
  return t === (t.ownerDocument || {}).body ? G(t) : {
    x: t.scrollLeft,
    y: t.scrollTop
  };
}
function ct(t) {
  var e = I(t);
  return e ? J(e) : { x: 0, y: 0 };
}
var ut = function(t, e) {
  var r = k(t), n = r.getComputedStyle(t), i = R(t), o = e || I(t), a = t.ownerDocument, l = o !== a.body && o !== a.documentElement, s = { top: 0, left: 0 };
  if (n.position !== "fixed" && l) {
    var c = r.getComputedStyle(o);
    s = R(o), s.top += parseInt(c.borderTopWidth, 10), s.left += parseInt(c.borderLeftWidth, 10);
  }
  return {
    top: i.top - s.top,
    left: i.left - s.left,
    height: i.height,
    width: i.width
  };
};
function pt(t, e) {
  return (
    // eslint-disable-line no-arrow-condition
    t ? J(t) : ct(e)
  );
}
function ht(t, e, r) {
  r === void 0 && (r = 1);
  var n = e ? I(e) : null, i = ut(t, n), o = i.top, a = i.left, l = i.height, s = i.width, c = pt(n, t), u = c.x, h = c.y, d = t.ownerDocument, g = n === d.body || n === d.documentElement ? 1 : r;
  return {
    top: o + h * g,
    left: a + u * g,
    height: l,
    width: s
  };
}
function vt(t, e) {
  return {
    top: t.top - e.y,
    left: t.left - e.x,
    height: t.height,
    width: t.width
  };
}
const b = {
  fit: "fit",
  flip: "flip",
  none: "none"
};
var F = function(t, e, r) {
  var n = 0;
  return t + e > r && (n = r - (t + e)), t < 0 && (n = -t), n;
}, K = function(t) {
  var e = t.offset, r = t.size, n = t.anchorSize, i = t.viewPortSize, o = t.anchorAlignPoint, a = t.elementAlignPoint, l = t.margin, s = 0, c = a === p.center || a === p.middle, u = o === p.center || o === p.middle, h = 2 * l;
  if (a !== o && !c && !u) {
    var d = o === p.top || o === p.left;
    e < 0 && d ? (s = r + n + h, e + s + r > i && (s = 0)) : e >= 0 && !d && (e + r > i && (s += -(n + r + h)), e + s < 0 && (s = 0));
  }
  return s;
}, dt = function(t) {
  var e = t.anchorRect, r = t.anchorAlign, n = t.elementRect, i = t.elementAlign, o = t.collisions, a = t.viewPort, l = t.margin;
  l === void 0 && (l = {});
  var s = n.top, c = n.left, u = n.height, h = n.width, d = a.height, g = a.width, y = l.horizontal || 0, m = l.vertical || 0, E = 0, C = 0, A = o.vertical === b.fit, S = o.horizontal === b.fit, L = o.vertical === b.flip, H = o.horizontal === b.flip;
  A && (C += F(s, u, d)), S && (E += F(c, h, g)), L && (C += K({
    margin: m,
    offset: s,
    size: u,
    anchorSize: e.height,
    viewPortSize: d,
    anchorAlignPoint: r.vertical,
    elementAlignPoint: i.vertical
  })), H && (E += K({
    margin: y,
    offset: c,
    size: h,
    anchorSize: e.width,
    viewPortSize: g,
    anchorAlignPoint: r.horizontal,
    elementAlignPoint: i.horizontal
  }));
  var W = L && C !== 0, V = H && E !== 0, U = A && C !== 0, j = S && E !== 0;
  return {
    flipped: V || W,
    fitted: U || j,
    flip: {
      horizontal: V,
      vertical: W
    },
    fit: {
      horizontal: j,
      vertical: U
    },
    offset: {
      left: E,
      top: C
    }
  };
};
function gt(t) {
  for (var e = [], r = t.parentNode.firstElementChild; r; )
    r !== t && e.push(r), r = r.nextElementSibling;
  return e;
}
function mt(t, e) {
  for (var r = q(t), n = e, i, o; n && (i = gt(n), o = r.reduce(
    function(a, l) {
      return a.concat(i.filter(function(s) {
        return s === l;
      }));
    },
    []
  )[0], !o); )
    n = n.parentElement;
  return o;
}
var wt = function(t, e) {
  return t || { height: 0, left: e.left, top: e.top, width: 0 };
}, yt = function(t, e) {
  return !t || e === 1 ? t : {
    height: t.height / e,
    left: t.left / e,
    top: t.top / e,
    width: t.width / e
  };
}, Pt = function(t, e) {
  if (!e)
    return t;
  var r = {
    height: t.height,
    left: t.left - e.left,
    top: t.top - e.top,
    width: t.width
  };
  return r;
};
function Ot(t) {
  var e, r = !1;
  return function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    return r || (e = t.apply(void 0, n), r = !0), e;
  };
}
var bt = Ot(function(t) {
  if (!Q())
    return !1;
  var e = t ? t.ownerDocument : document;
  if (!e || !e.body)
    return !1;
  var r = 10, n = e.createElement("div");
  n.style.transform = "matrix(10, 0, 0, 10, 0, 0)", n.innerHTML = '<div style="position: fixed; top: ' + r + 'px;">child</div>', e.body.appendChild(n);
  var i = n.children[0].getBoundingClientRect().top !== r;
  return e.body.removeChild(n), i;
}), Q = function() {
  return !!// from fbjs
  (typeof window < "u" && window.document && window.document.createElement);
}, O = {
  eitherRect: wt,
  scaleRect: yt,
  removeStackingOffset: Pt,
  hasRelativeStackingContext: bt,
  canUseDOM: Q
}, At = [
  "font-size",
  "font-family",
  "font-stretch",
  "font-style",
  "font-weight",
  "line-height"
], Et = function(t, e) {
  return {
    left: t.left + e.left,
    top: t.top + e.top
  };
}, tt = function() {
  return O.canUseDOM() ? window : null;
}, xt = function(t) {
  var e = tt();
  if (!e || !t)
    return [];
  var r = e.getComputedStyle(t);
  return At.map(function(n) {
    return { key: n, value: r[n] };
  });
}, Ct = function(t) {
  return t ? !!t.offsetParent : !1;
}, _t = function(t) {
  return t ? R(t) : null;
}, Rt = function(t, e) {
  if (!t)
    return null;
  var r = t.style, n = r.left, i = r.top, o = r.transition;
  t.style.transition = "none", t.style.left = e.left + "px", t.style.top = e.top + "px";
  var a = R(t);
  return t.style.left = n, t.style.top = i, t.offsetHeight, t.style.transition = o, a;
}, Tt = function(t, e, r) {
  if (!t || !e)
    return null;
  var n = r || 1;
  return ht(t, e, n);
}, St = /auto|scroll/, zt = function(t) {
  return "" + t.style.overflow + t.style.overflowX + t.style.overflowY;
}, Dt = function(t) {
  var e = window.getComputedStyle(t);
  return "" + e.overflow + e.overflowX + e.overflowY;
}, Nt = function(t) {
  return zt(t) || Dt(t);
}, kt = function(t) {
  var e = [];
  if (!O.canUseDOM())
    return e;
  for (var r = t.parentElement; r; )
    (St.test(Nt(r)) || r.hasAttribute("data-scrollable")) && e.push(r), r = r.parentElement;
  return e.push(window), e;
}, T = function(t) {
  if (!t || !O.hasRelativeStackingContext())
    return null;
  for (var e = t.parentElement; e; ) {
    if (window.getComputedStyle(e).transform !== "none")
      return e;
    e = e.parentElement;
  }
  return null;
}, Mt = function(t) {
  var e = T(t);
  return e ? R(e) : null;
}, It = function(t) {
  var e = T(t);
  return e ? {
    x: e.scrollLeft,
    y: e.scrollTop
  } : { x: 0, y: 0 };
}, Lt = function(t) {
  var e = T(t);
  return e ? {
    height: e.scrollHeight,
    width: e.scrollWidth
  } : null;
}, Ht = function(t) {
  return !!T(t);
}, et = function() {
  return O.canUseDOM() && parseFloat((document.documentElement.clientWidth / window.innerWidth).toFixed(2)) || 1;
}, Wt = function() {
  return et() > 1;
}, Vt = function(t, e) {
  if (!t || !O.canUseDOM())
    return null;
  var r = mt(t, e);
  if (!r)
    return null;
  var n = [t].concat(q(t, r)).reduce(
    function(i, o) {
      var a = o.style.zIndex || window.getComputedStyle(o).zIndex, l = parseInt(a, 10);
      return l > i ? l : i;
    },
    0
  );
  return n ? n + 1 : null;
}, w = {
  addOffset: Et,
  addScroll: at,
  align: ot,
  boundingOffset: st,
  getFontStyles: xt,
  getWindow: tt,
  hasOffsetParent: Ct,
  offset: _t,
  offsetAtPoint: Rt,
  position: Tt,
  removeScroll: vt,
  restrictToView: dt,
  scrollPosition: G,
  scrollableParents: kt,
  getRelativeContextElement: T,
  stackingElementOffset: Mt,
  stackingElementScroll: It,
  stackingElementViewPort: Lt,
  useRelativePosition: Ht,
  windowViewPort: Y,
  zoomLevel: et,
  isZoomed: Wt,
  zIndex: Vt
}, Ut = function(t, e, r, n) {
  var i = Ft(t, e), o = O.eitherRect(w.offset(t), r), a = 2 * n, l = w.stackingElementScroll(e);
  n !== 1 && l && (l.x /= a, l.y /= a);
  var s = w.stackingElementOffset(e);
  return n !== 1 && s && (s.left /= a, s.top /= a), w.removeScroll(
    w.addScroll(
      O.removeStackingOffset(
        O.scaleRect(o, n),
        s
      ),
      l
    ),
    i
  );
}, jt = function(t, e, r, n) {
  var i = O.eitherRect(w.position(t, e, n), r);
  return O.scaleRect(i, n);
}, Ft = function(t, e) {
  return t ? { x: 0, y: 0 } : w.scrollPosition(e);
}, Kt = function(t) {
  var e = t.anchor, r = t.element, n = t.anchorAlign, i = t.elementAlign, o = t.margin, a = t.offset, l = t.positionMode, s = t.scale, c = s || 1, u = l === "fixed" || !w.hasOffsetParent(r), h = u ? Ut(e, r, a, c) : jt(e, r, a, c), d = O.scaleRect(w.offset(r), c), g = w.align({
    anchorAlign: n,
    anchorRect: h,
    elementAlign: i,
    elementRect: d,
    margin: o
  });
  return g;
}, Bt = function(t) {
  var e = t.anchor, r = t.currentLocation, n = t.element, i = t.anchorAlign, o = t.elementAlign, a = t.collisions, l = t.margin, s = t.scale, c = s || 1, u = w.offsetAtPoint(n, r), h = O.scaleRect(u, c), d = O.scaleRect(w.offset(e), c), g = O.eitherRect(d, r), y = t.viewPort || w.windowViewPort(n);
  y.width = y.width / c, y.height = y.height / c;
  var m = w.restrictToView({
    anchorAlign: i,
    anchorRect: g,
    collisions: a,
    elementAlign: o,
    elementRect: h,
    margin: l,
    viewPort: y
  }), E = w.addOffset(r, m.offset);
  return {
    flip: m.flip,
    flipped: m.flipped,
    offset: E
  };
}, B = function(t) {
  t.style.transitionDuration = "", Array.from(t.classList).forEach(function(e) {
    e.startsWith("k-slide-") && t.classList.remove(e);
  });
}, $t = typeof window < "u" && /Firefox/.test(window.navigator.userAgent), Zt = function(t, e, r, n, i) {
  if (r === 0)
    return i();
  var o = "k-slide-" + e + "-" + n, a = o + "-active", l = function(h) {
    h.target === t && (t.removeEventListener("transitionend", l), B(t), n === "exit" ? t.style.display = "none" : t.style.display = "", i());
  };
  t.addEventListener("transitionend", l);
  var s = t.ownerDocument;
  if (s) {
    var c = s.defaultView;
    if (c) {
      var u = function() {
        B(t), t.classList.add(o), c.requestAnimationFrame(function() {
          t.style.transitionDuration = r + "ms", t.classList.add(a);
        });
      };
      $t ? c.requestAnimationFrame(u) : u();
    }
  }
}, D = x.createContext(0);
D.displayName = "KendoReactZIndexContext";
var Xt = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), $ = function() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = {}, n = function(o) {
    return typeof o == "object" ? Object.keys(o).forEach(function(a) {
      r[a] = o[a];
    }) : r[o] = !0;
  }, i = function(o) {
    return o.filter(function(a) {
      return a !== !0 && !!a;
    }).map(function(a) {
      return Array.isArray(a) ? i(a) : n(a);
    });
  };
  return i(t), Object.keys(r).map(function(o) {
    return r[o] && o || null;
  }).filter(function(o) {
    return o !== null;
  }).join(" ");
};
function Yt(t) {
  if (typeof rt < "u")
    it(t);
  else {
    var e = "License activation failed for ".concat(t.name, `
`);
    e += `The @progress/kendo-licensing script is not loaded.
`, e += "See ".concat(t.licensingDocsUrl, ` for more information.
`), console.warn(e);
  }
}
var qt = 1e3 / 60, Gt = function(t, e, r) {
  r === void 0 && (r = {});
  var n, i, o, a, l = 0;
  r = r || {};
  var s = function() {
    l = r.leading === !1 ? 0 : (/* @__PURE__ */ new Date()).getTime(), n = void 0, a = t.apply(i, o), n || (i = o = null);
  }, c = function() {
    var u = (/* @__PURE__ */ new Date()).getTime();
    !l && r.leading === !1 && (l = u);
    var h = e - (u - l);
    return i = void 0, o = arguments, h <= 0 || h > e ? (n && (clearTimeout(n), n = void 0), l = u, a = t.apply(i, o), n || (i = o = null)) : !n && r.trailing !== !1 && (n = window.setTimeout(s, h)), a;
  };
  return c;
}, Jt = {
  name: "@progress/kendo-react-popup",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1690379951,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Qt = globalThis && globalThis.__extends || function() {
  var t = function(e, r) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, t(e, r);
  };
  return function(e, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    t(e, r);
    function n() {
      this.constructor = e;
    }
    e.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), P = globalThis && globalThis.__assign || function() {
  return P = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, P.apply(this, arguments);
}, te = 100, ee = 1;
function _(t, e) {
  if (t === e)
    return !0;
  if (!!t != !!e)
    return !1;
  var r = Object.getOwnPropertyNames(t), n = Object.getOwnPropertyNames(e);
  if (r.length !== n.length)
    return !1;
  for (var i = 0; i < r.length; i++) {
    var o = r[i];
    if (t[o] !== e[o])
      return !1;
  }
  return !0;
}
var ne = {
  left: -1e3,
  top: 0
}, v;
(function(t) {
  t.hiding = "hiding", t.hidden = "hidden", t.showing = "showing", t.shown = "shown", t.reposition = "reposition";
})(v || (v = {}));
var re = "k-animation-container", Z = "k-animation-container-shown", ie = "k-animation-container-relative", oe = "k-child-animation-container", ae = "k-popup", le = (
  /** @class */
  function(t) {
    Qt(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.context = 0, n.state = { current: v.hidden, previous: v.hidden, props: {} }, n._popup = null, n.show = function(i) {
        n.setPosition(i), n.animate(i.firstChild, "enter", n.onOpened), n.setState({ current: v.shown, previous: n.state.current });
      }, n.setPosition = function(i) {
        var o = n.props, a = o.anchorAlign, l = o.popupAlign, s = o.collision, c = o.offset, u = o.anchor, h = o.margin, d = o.scale, g = o.positionMode, y = i.style, m = y.width, E = y.height;
        i.style.width = i.offsetWidth + "px", i.style.height = i.offsetHeight + "px";
        var C = Kt({
          anchor: u,
          anchorAlign: a,
          element: i,
          elementAlign: l,
          offset: c,
          margin: h,
          positionMode: g,
          scale: d
        }), A = Bt({
          anchor: u,
          anchorAlign: a,
          element: i,
          elementAlign: l,
          collisions: s,
          currentLocation: C,
          margin: n.props.margin
        });
        if (i.style.top = A.offset.top + "px", i.style.left = A.offset.left + "px", i.style.width = m, i.style.height = E, n._collisions = {
          fit: A.fit,
          fitted: A.fitted,
          flip: A.flip,
          flipped: A.flipped
        }, n.props.onPosition) {
          var S = {
            target: n,
            flipped: A.flipped,
            fitted: A.fitted
          };
          n.props.onPosition.call(void 0, S);
        }
      }, n.onOpened = function() {
        var i = n._popup;
        i && (n.props.show && i.classList.add(Z), n.attachRepositionHandlers(i), n.props.onOpen && n.props.onOpen.call(void 0, { target: n }));
      }, n.animate = function(i, o, a) {
        if (n.props.popupAlign) {
          var l, s = n.props.popupAlign, c = s.horizontal, u = s.vertical;
          c === "left" && u === "center" ? l = "right" : c === "right" && u === "center" ? l = "left" : u === "top" ? l = "down" : l = "up";
          var h = {
            down: "up",
            up: "down",
            left: "right",
            right: "left"
          };
          n._collisions && n._collisions.flipped && (l = h[l]), Zt(i, l, n.animationDuration[o], o, a);
        }
      }, n.onClosing = function(i) {
        n.props.show || i.classList.remove(Z), n.detachRepositionHandlers();
      }, n.onClosed = function() {
        n.state.current === v.hiding && n.state.previous === v.shown && n.setState({ current: v.hidden, previous: n.state.current }), n.props.onClose && n.props.onClose.call(void 0, { target: n });
      }, n.getCurrentZIndex = function() {
        return n.context ? n.context + ee : te;
      }, Yt(Jt), n.reposition = Gt(n.reposition.bind(n), qt), n;
    }
    return Object.defineProperty(e.prototype, "element", {
      /**
       * Represents the Popup DOM element.
       */
      get: function() {
        return this._popup;
      },
      enumerable: !1,
      configurable: !0
    }), e.getDerivedStateFromProps = function(r, n) {
      var i = r.show, o = r.anchor, a = r.anchorAlign, l = r.appendTo, s = r.collision, c = r.popupAlign, u = r.className, h = r.popupClass, d = r.style, g = r.offset, y = r.contentKey, m = P(P({}, n), { props: {
        show: i,
        anchor: o,
        anchorAlign: a,
        appendTo: l,
        collision: s,
        popupAlign: c,
        className: u,
        popupClass: h,
        style: d,
        offset: g,
        contentKey: y
      } });
      return r.show ? n.current === v.hidden || n.current === v.hiding ? P(P({}, m), { current: v.showing, previous: n.current }) : n.current === v.showing ? P(P({}, m), { current: v.shown, previous: n.current }) : n.current === v.shown && (!_(g, n.props.offset) || !_(a, n.props.anchorAlign) || !_(l, n.props.appendTo) || !_(s, n.props.collision) || !_(c, n.props.popupAlign) || !_(d, n.props.style) || o !== n.props.anchor || h !== n.props.popupClass || u !== n.props.className) ? P(P({}, m), { current: v.reposition, previous: n.current }) : m : n.current === v.hiding || n.current === v.hidden ? P(P({}, m), { current: v.hidden, previous: n.current }) : P(P({}, m), { current: v.hiding, previous: n.current });
    }, e.prototype.componentDidUpdate = function(r) {
      this.state.current === v.showing && this._popup ? this.show(this._popup) : this.state.current === v.hiding && this._popup ? (this.onClosing(this._popup), this.animate(this._popup.firstChild, "exit", this.onClosed)) : this.state.current === v.reposition && this.state.previous === v.shown ? this.setState({ current: v.shown, previous: this.state.current }) : this.state.current === v.shown && r.contentKey !== this.props.contentKey && this._popup && this.setPosition(this._popup);
    }, e.prototype.componentDidMount = function() {
      this.state.current === v.showing && this._popup && this.show(this._popup);
    }, e.prototype.componentWillUnmount = function() {
      this.detachRepositionHandlers();
    }, e.prototype.render = function() {
      var r = this, n = this.props, i = n.children, o = n.className, a = n.popupClass, l = n.show, s = n.id, c = n.positionMode, u = this.props.appendTo ? this.props.appendTo : Xt ? this.props.anchor && this.props.anchor.ownerDocument ? this.props.anchor.ownerDocument.body : document.body : void 0;
      this.state.current === v.reposition && this.state.previous === v.shown && this._popup && this.setPosition(this._popup);
      var h = Object.assign({}, { position: c, top: 0, left: -1e4 }, this.props.style || {}), d = this.state.current === v.hiding;
      if ((l || d) && u) {
        var g = this.getCurrentZIndex(), y = x.createElement(
          D.Provider,
          { value: g },
          x.createElement(
            "div",
            { className: $(re, ie, o), id: s, ref: function(m) {
              return r._popup = m;
            }, style: P({ zIndex: g }, h) },
            x.createElement("div", { role: this.props.role, className: $(ae, a, oe), style: { transitionDelay: "0ms" } }, i)
          )
        );
        return this.props.appendTo !== null ? nt.createPortal(y, u) : y;
      }
      return null;
    }, Object.defineProperty(e.prototype, "animationDuration", {
      get: function() {
        var r = this.props.animate, n = 0, i = 0;
        return r && (r === !0 ? n = i = 300 : (n = r.openDuration || 0, i = r.closeDuration || 0)), { enter: n, exit: i };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.attachRepositionHandlers = function(r) {
      var n = this;
      this.detachRepositionHandlers(), this._scrollableParents = w.scrollableParents(this.props.anchor || r), this._scrollableParents && this._scrollableParents.map(function(i) {
        return i.addEventListener("scroll", n.reposition);
      }), window.addEventListener("resize", this.reposition);
    }, e.prototype.detachRepositionHandlers = function() {
      var r = this;
      this._scrollableParents && (this._scrollableParents.map(function(n) {
        return n.removeEventListener("scroll", r.reposition);
      }), this._scrollableParents = void 0), window.removeEventListener("resize", this.reposition);
    }, e.prototype.reposition = function() {
      this.setState({ current: v.reposition, previous: this.state.current });
    }, e.propTypes = {
      anchor: function(r) {
        var n = r.anchor;
        return n && typeof n.nodeType != "number" ? new Error("Invalid prop `anchor` supplied to `Kendo React Popup`. Validation failed.") : null;
      },
      appendTo: function(r) {
        var n = r.appendTo;
        return n && typeof n.nodeType != "number" ? new Error("Invalid prop `appendTo` supplied to `Kendo React Popup`. Validation failed.") : null;
      },
      className: f.oneOfType([
        f.string,
        f.arrayOf(f.string),
        f.object
      ]),
      id: f.string,
      popupClass: f.oneOfType([
        f.string,
        f.arrayOf(f.string),
        f.object
      ]),
      collision: f.shape({
        horizontal: f.oneOf([
          b.fit,
          b.flip,
          b.none
        ]),
        vertical: f.oneOf([
          b.fit,
          b.flip,
          b.none
        ])
      }),
      anchorAlign: f.shape({
        horizontal: f.oneOf([
          p.left,
          p.center,
          p.right
        ]),
        vertical: f.oneOf([
          p.top,
          p.center,
          p.bottom
        ])
      }),
      popupAlign: f.shape({
        horizontal: f.oneOf([
          p.left,
          p.center,
          p.right
        ]),
        vertical: f.oneOf([
          p.top,
          p.center,
          p.bottom
        ])
      }),
      offset: f.shape({
        left: f.number,
        top: f.number
      }),
      children: f.oneOfType([
        f.element,
        f.node
      ]),
      show: f.bool,
      animate: f.oneOfType([
        f.bool,
        f.shape({
          openDuration: f.number,
          closeDuration: f.number
        })
      ]),
      margin: f.shape({
        horizontal: f.number,
        vertical: f.number
      }),
      positionMode: f.oneOf([
        "fixed",
        "absolute"
      ]),
      scale: f.number,
      style: f.object,
      onClose: f.func,
      onPosition: f.func,
      onOpen: f.func
    }, e.defaultProps = {
      collision: {
        horizontal: b.fit,
        vertical: b.flip
      },
      anchorAlign: {
        horizontal: p.left,
        vertical: p.bottom
      },
      popupAlign: {
        horizontal: p.left,
        vertical: p.top
      },
      offset: ne,
      animate: !0,
      show: !1,
      margin: {
        horizontal: 0,
        vertical: 0
      },
      positionMode: "absolute"
    }, e.contextType = D, e.displayName = "PopupComponent", e;
  }(x.Component)
), N = globalThis && globalThis.__assign || function() {
  return N = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, N.apply(this, arguments);
}, se = x.createContext(function(t) {
  return t;
}), fe = x.forwardRef(function(t, e) {
  var r = x.useContext(se), n = r.call(void 0, t);
  return x.createElement(le, N({ ref: e }, n));
});
fe.displayName = "Popup";
export {
  p as A,
  b as C,
  se as P,
  fe as a,
  Kt as b,
  w as d,
  Bt as p
};
